import { Component, Input, OnInit } from '@angular/core';
import {ChartOptions,ChartConfiguration} from 'chart.js';

@Component({
  selector: 'kt-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit {

  @Input() chartLabels: string[] = []; // Input for chart labels
  @Input() isSmooth: boolean = false;
  @Input() chartData: { label: string; data: number[] }[] = []; // Input for datasets
  @Input() chartOptions: ChartOptions = {
    // responsive: true,
    legend: {
      display: true,
      position: 'bottom'
    },
    scales: {
      xAxes: [{ 
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10
        }
      }],
      yAxes: [{  
        ticks: {
          beginAtZero: true,
          stepSize: 1
        }
      }]
    }
  };

  public lineChartType: 'line' = 'line'; // Chart type
  public lineChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [],
  };

  ngOnInit(): void {
    this.initializeChart();
  }

  private initializeChart(): void {
    this.lineChartData.labels = this.chartLabels;
    this.lineChartData.datasets = this.chartData.map((dataset) => ({
      data: dataset.data,
      label: dataset.label,
      // borderColor: this.getRandomColor(),
      backgroundColor: 'rgba(0,0,0,0)', // Transparent for line charts
      tension: this.isSmooth? 0.4 : 0, // Smooth lines
    }));
  }

  private getRandomColor(): string {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgba(${r},${g},${b},1)`;
  }

}
